<mat-dialog-content>
  <div class="card-heading mb-2">Transaction details</div>
  <div class="d-flex">
    <div class="col-md-7 p-0">
      <div>
        <div class="detail-height" *ngIf="CONFIG_ === undefined">
          <div class="label-name mb-1">MCC</div>
          <div class="sub-details">
            {{
              details?.transaction_object?.merchant?.category
                ? details?.transaction_object?.merchant?.category
                : "-"
            }}
          </div>
        </div>

        <div class="detail-height" *ngIf="CONFIG_ !== undefined">
          <div class="label-name mb-1">Status</div>
          <div class="sub-details">
            {{ details?.status }}
          </div>
        </div>
        <div class="detail-height">
          <div class="label-name mb-1">Wallet Type</div>
          <div class="sub-details">
            {{ WALLETS?.walletName }}
          </div>
        </div>
        <div class="detail-height">
          <div class="label-name mb-1">Amount</div>

          <div class="sub-details">
            {{ WALLETS?.amount }}
          </div>
        </div>
        <div class="detail-height" *ngIf="CONFIG_ === undefined">
          <div class="label-name mb-1">Sender Relation</div>
          <div class="sub-details">
            {{ transaction?.sender_receiver_relationship }}
          </div>
        </div>
        <div class="detail-height" *ngIf="CONFIG_ === undefined">
          <div class="label-name mb-1">Location</div>
          <div class="sub-details">{{ merchant }}</div>
        </div>
        <div
          class="detail-height"
          *ngIf="transaction?.cash_out_partner_name != undefined"
        >
          <div class="label-name mb-1">Cash out partner</div>
          <div class="sub-details">
            {{ transaction?.cash_out_partner_name }}
          </div>
        </div>
        <div class="detail-height" *ngIf="CONFIG_ !== undefined">
          <div class="label-name mb-1">Reference number</div>
          <div class="sub-details">
            {{ details?.partner_reference }}
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-5 p-0">
      <div class="detail-height">
        <div class="label-name mb-1">Send date</div>
        <div class="sub-details">
          {{ sendDate }}
        </div>
      </div>
      <div class="detail-height">
        <div class="label-name mb-1">Beneficiary name</div>
        <div class="sub-details" style="color: '#66023C'">
          {{ beneficiary }}
        </div>
      </div>
      <div class="detail-height">
        <div class="label-name mb-1">Currency</div>
        <div class="sub-details">
          {{ WALLETS?.currency }}
        </div>
      </div>
      <div class="detail-height" *ngIf="CONFIG_ === undefined">
        <div class="label-name mb-1">Transfer reason</div>
        <div class="sub-details">
          {{ transaction?.purpose }}
        </div>
      </div>
      <div class="detail-height" *ngIf="CONFIG_ === undefined">
        <div class="label-name mb-1">Address</div>
        <div class="sub-details">{{ address }}</div>
      </div>
      <div
        class="detail-height"
        *ngIf="transaction?.cash_out_source_type != undefined"
      >
        <div class="label-name mb-1">Wallet source type</div>
        <div class="sub-details">
          {{ transaction?.cash_out_source_type }}
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-12 p-0">
    <!-- Status History -->
    <div class="label_ mb-2 ml-1">Status History:</div>
    <div class="container-view">
      <table class="table table-bordered listing-table">
        <tbody>
          <tr *ngFor="let col of STATUS_HISTORY" class="cell_">
            <td>
              <div class="label_ mb-1 ml-1">
                {{ col.status | titlecase }}
              </div>
            </td>
            <td>
              <div class="label-text-value ml-1">
                {{
                  (col?.datetime_updated
                    ? col?.datetime_updated
                    : col?.updatedAt
                  ) | date : "medium"
                }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</mat-dialog-content>
<mat-dialog-actions class="actions-btn pull-right">
  <a class="button button-text close" (click)="close()"> Close</a>
</mat-dialog-actions>
